import { ThumbsUp, ThumbsDown } from 'lucide-react';

export enum FeedbackRating {
  POSITIVE = 1,
  NEGATIVE = -1,
}

export interface Rating {
  id: number;
  icon: React.ComponentType<{ strokeWidth?: number; className?: string }>;
  label: string;
  value: FeedbackRating;
  hoverClass: string;
  selectedClass: string;
}

export const RATINGS: Rating[] = [
  {
    id: 1,
    icon: ThumbsUp,
    label: 'Helpful',
    value: FeedbackRating.POSITIVE,
    hoverClass: 'hover:text-green-500 dark:hover:text-green-400',
    selectedClass: 'text-green-500 dark:text-green-400',
  },
  {
    id: 2,
    icon: ThumbsDown,
    label: 'Not helpful',
    value: FeedbackRating.NEGATIVE,
    hoverClass: 'hover:text-red-500 dark:hover:text-red-400',
    selectedClass: 'text-red-500 dark:text-red-400',
  },
];
